// Where a widget someone adds goes on a mind map board: on its canvas, where it was asked for (a double click,
// a drop) or near the middle of the view, but never over the map's ideas: beside them, on free ground.

import { GRID } from "../../../shared/catalog";
import type { WidgetItem } from "../../../shared/types";
import { viewportCenter } from "../../canvas/camera";
import { boardItems, get } from "../../state/store";
import type { Placement } from "../kinds";
import { liveMap } from "./live";

export function placeBesideMap(item: WidgetItem): Placement {
  const map = liveMap(item.boardId)?.bounds();
  const gap = 32;
  const others = boardItems(get(), item.boardId).filter((i) => i.kind === "widget" && i.id !== item.id);
  const blocked = [...others, ...(map ? [{ x: map.x - gap, y: map.y - gap, w: map.w + gap * 2, h: map.h + gap * 2 }] : [])];
  const hits = (x: number, y: number) => blocked.some((r) => x < r.x + r.w + 24 && x + item.w + 24 > r.x && y < r.y + r.h + 24 && y + item.h + 24 > r.y);
  if (!hits(item.x, item.y)) return { ops: [{ op: "item.put", item }], onCanvas: true };
  // outward from where it was going, in rings, to the first free ground
  const c = map && !others.length ? { x: item.x + item.w / 2, y: item.y + item.h / 2 } : viewportCenter();
  const snap = (v: number) => Math.round(v / GRID) * GRID;
  for (let r = 1; r < 80; r++) {
    for (let a = 0; a < 8 * r; a++) {
      const ang = (a / (8 * r)) * Math.PI * 2;
      const x = snap(c.x - item.w / 2 + Math.cos(ang) * r * 56);
      const y = snap(c.y - item.h / 2 + Math.sin(ang) * r * 40);
      if (!hits(x, y)) return { ops: [{ op: "item.put", item: { ...item, x, y } }], onCanvas: true };
    }
  }
  return { ops: [{ op: "item.put", item }], onCanvas: true };
}
